import { Injectable, inject } from '@angular/core';

import { UrlService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class CrmOfferPreviewService {
    private urlService = inject(UrlService);

    get offerParams(): { offerId: string; cmsItemId: string } | undefined {
        const offerId = this.urlService.current().search.get('offerId');
        const cmsItemId = this.urlService.current().search.get('sitecoreId');

        return offerId && cmsItemId ? { offerId, cmsItemId } : undefined;
    }

    get inPreview(): boolean {
        return !!this.offerParams;
    }
}
